import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {BaseViewElement} from '../base-view-element';
import {PropertySet} from '../../../core/model/helper-models/property-set.model';
import {Property} from '../../../core/model/helper-models/property.model';

@Component({
    selector: 'app-olps-distance',
    templateUrl: './olps-distance.component.html',
    styleUrls: ['./olps-distance.component.scss',
        './../card.scss'],
    standalone: false
})
export class OlpsDistanceComponent extends BaseViewElement implements OnInit, OnChanges
{
    @Input() Distance: PropertySet;

    distanceEmpty: Property<any>;
    distanceLoaded: Property<any>;

    constructor()
    {
        super('olps-distance');
    }

    onResize(result: any)
    {
        this.childResizeEvent.emit(result);
    }

    ngOnChanges(changes: SimpleChanges): void
    {
        if (this.Distance == null)
        {
            this.distanceEmpty = null;
            this.distanceLoaded = null;
        }
        else
        {
            this.distanceEmpty = this.Distance.properties.get('KM_COUNTER_EMPTY');
            this.distanceLoaded = this.Distance.properties.get('KM_COUNTER_LOADED');
        }
    }
}
